module.exports = __webpack_public_path__ + "34bc775d/img/boston-lights.a623432f.png";